import {useEffect, useState} from 'react';
import {GET_COLLECTION_AGGREGATE_DATA, SEARCH_COLLECTION_URL} from '../../api';
import 'datatables.net';
import 'datatables.net-responsive';
import $ from "jquery";
import {Link} from "react-router-dom";
import cogoToast from "cogo-toast";
import {group} from "../../api/app";
import {capitalize} from "../../utils/capitalize";
import DTAgent from "../../components/layout/DTAgent";

let searchableFields = [
    { field: 'username', isNumeric: false },
    { field: 'name', isNumeric: false },
    { field: 'role', isNumeric: false }
]

const Network = () => {

    document.title = "Network";

    const [stateReady, setStateReady] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [editId, setEditId] = useState(0);
    const [id, setId] = useState(new Date().getTime());
    const [groupId, setGroupId] = useState(null);
    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        let table = $('#group-table').DataTable({
            responsive: true,
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Network Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "group",
                        searchableFields,
                        filter: {},
                        populate: [
                            {
                                path: 'admin',
                                model: 'agent'
                            }
                        ],
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success : function(res) {
                        let array = [];

                        res.data.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.name;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return {
                            main : `<span class="badge badge-secondary tx-white">Main</span>`,
                            special : `<span class="badge badge-info tx-white">Special</span>`
                        }[data.network];
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return {
                            true : `<span class="badge badge-success tx-white">Active</span>`,
                            false : `<span class="badge badge-danger tx-white">Inactive</span>`
                        }[data.active];
                    },
                    "targets": 2
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link group_membership"><i class="fa fa-eye"></i> View</a> <a href="#" class="nav-link edit_group"><i class="fa fa-pencil"></i> Edit</a> <a href="#" class="nav-link delete_group"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 3
                }
            ]
        });

        table.on('click', '.delete_group', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this account?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                group("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("Group successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.edit_group', function (e) {
            e.preventDefault();

            let agent_select = $("#agent-select2");

            const extract_td = table.row($(this).closest('tr')).data();
            setEditForm(true);
            setEditId(extract_td.raw._id);

            $("#name").val(extract_td.raw.name);
            $("#network").val(extract_td.raw.network);

            let $option = $("<option selected></option>").val(extract_td.raw.admin._id).text(extract_td.raw.admin.name);
            agent_select.append($option).trigger('change');

            initialize();

            $('#group_form').parsley();
            $("#modalGroup").modal("show");
        });

        table.on('click', '.group_membership', function (e) {
            e.preventDefault();

            const extract_td = table.row($(this).closest('tr')).data();

            $("#group-name").text(extract_td.raw.name);
            $("#leader-name").text(extract_td.raw.admin.name);

            setGroupId(extract_td.raw._id);

            setId(new Date().getTime());
            $("#modalGroupMembership").modal("show");
        });

        return () => {
            table.destroy();
        }
    }, []);

    const initialize = () => {
        let modalGroup = $('#modalGroup');
        $('#agent-select2').select2({
            placeholder: 'Select agent',
            allowClear: true,
            width:"100%",
            maximumSelectionLength: 1,
            dropdownParent: modalGroup,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization": token,
                },
                data: function(query) {
                    return {
                        query: query,
                        collection: "agent"
                    };
                },
                processResults: function(data) {
                    return {
                        results: $.map(data, function(item) {
                            return {
                                text: capitalize(`${item.name} - ${item.id_number || "Unassigned"}`),
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let name = $('#name').val();
        let network = "main";
        let agent = $('#agent-select2').val()[0];

        let data = {
            name,
            network,
            agent
        };

        if(editForm) {
            Object.assign(data, {id: editId});
            group("put", data).then((result) => {
                setStateReady(false);
                if(!result.error) {
                    cogoToast.success("Group successfully updated.", {position: "top-right", hideAfter: 5});
                    resetForm("modalGroup", "group_form");
                    reloadTable();
                }
            });

            return false;
        }

        setStateReady(true);

        group("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Account successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalGroup", "group_form");
                reloadTable();
            }
        });
    };

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        $('#province, #constituency, #ward, #polling_station')
            .val(null)
            .trigger('change')
            .empty();
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const handleShowModal = () => {
        setEditForm(false);
        $('#group_form').parsley();

        initialize();
        $("#modalGroup").modal("show");
    };

    const reloadTable = () => {
        $('#group-table').DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Network</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Network</h4>
                    </div>
                    <div className="d-none d-md-block">
                         <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-user-plus"></i> Add New</button>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Network List</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable.bind()} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="group-table" className="table">
                                    <thead>
                                    <tr>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">Type</th>
                                        <th className="wd-20p">Active</th>
                                        <th className="wd-20p">Actions</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalGroup" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalGroup", "group_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">{editForm ? "Edit Network" : "Create Network"}</h4><p className="tx-13 tx-color-02 mg-b-0">{editForm ? "Edit" : "Network"} user to have access to the console</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="group_form" className="parsley-style-1" onSubmit={handleSubmit.bind()}>
                                        <div id="nameWrapper" className="form-group parsley-input">
                                            <label>Name<span className="tx-danger">*</span></label>
                                            <input id="name" type="text" className="form-control"
                                                   placeholder="Enter full name"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#nameWrapper" required/>
                                        </div>

                                        <div id="agentWrapper" className="form-group parsley-input">
                                            <label>Admin</label>
                                            <select id="agent-select2"
                                                    data-width="100%"
                                                    multiple="multiple"
                                                    data-parsley-class-handler="#agentWrapper"
                                                    data-parsley-errors-container="#agentWrapper"
                                                    className="custom-select"
                                                    required
                                            >
                                            </select>
                                        </div>

                                        {stateReady ? <button disabled className="btn btn-primary btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : editForm ? <button className="btn btn-primary btn-block">Update Network</button> : <button className="btn btn-primary btn-block">Create Network</button>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p className="mg-b-0 data-message">Empty</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                    <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalGroupMembership" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2" id="group-name">Membership Zone</h4><p className="tx-13 tx-color-02 mg-b-0">Leader: <span id="leader-name"></span></p></div>
                                </div>
                                <div className="modal-body">
                                    <DTAgent id={id} group_id={groupId} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Network;
